var $ = jQuery.noConflict();

$(document).ready(function(){

    var is_desktop = $('body').hasClass('desktop'); 

    // no desktop
    if(is_desktop == false){
        $('.no-flash').each(function(){
            $(this).fadeIn();
        });
    }
    else{
        $('.flash-wrapper').fadeIn();
    }

});


// WEBPACK FOOTER //
// ./assets/js/flash.js